import { CardType } from '@shared/cards-types';
import { t } from '@luna/i18n';

export const getLocalizedCardType = (cardType?: CardType | null): string => {
    switch (cardType) {
        case CardType.MAIN:
            return t('transaction.cardType_H');
        case CardType.ADDITIONAL:
            return t('transaction.cardType_Z');
        default:
            return '';
    }
};
